module.exports = __webpack_public_path__ + "static/Tellonym-83a30efb195936b78ca109e884dab5dc.png";